import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { errorMessages } from '../../../../utils/errors/constants';
import { resolve } from '../../../../utils/object/pathResolver';

const CheckboxQuestionItem = ({
  rendering,
  fields,
  id,
  error,
  setError,
  onError,
  defaultValue,
  trackChild,
}) => {
  const [checked, setChecked] = useState(defaultValue);
  const errorClass = error ? ' vds-checkbox--invalid' : '';
  const dispatch = useDispatch();

  const setErrorWithContent = errorType => {
    const errorMessage = fields[errorType]?.value || errorType;
    const dispatchData = errorType
      ? { type: errorType, message: errorMessage, inline: fields.inlineError?.value }
      : null;
    if (typeof onError === 'function') {
      onError(dispatchData);
    }
    setError(dispatchData);
  };

  const handleChange = () => {
    const value = !checked;
    setChecked(value);
    if (!value && fields.required?.value) {
      setErrorWithContent(errorMessages.EMPTY);
    } else {
      trackChild(rendering.uid, value);
      const index = fields.reduxDispatchType?.payload?.index;
      const dispatchData = {
        type: fields.reduxDispatchType?.value,
        payload: index >= 0 ? { value, index } : value,
      };
      dispatch(dispatchData);
      setErrorWithContent(null);
    }
  };

  useEffect(() => {
    if (fields.required?.value && !checked && !defaultValue) {
      setErrorWithContent(errorMessages.EMPTY);
    }
  }, []);

  return (
    <div className={`vds-checkbox__item${errorClass}`}>
      <input
        type="checkbox"
        className={`vds-checkbox__input${errorClass}`}
        id={`${id}_${fields.value?.value}`}
        name={id}
        value={fields.value?.value}
        checked={checked}
        onChange={handleChange}
        required={fields.required?.value}
        data-testid={fields.testid?.value}
      />
      <Text
        tag="label"
        className="vds-checkbox__label"
        htmlFor={`${id}_${fields.value?.value}`}
        field={fields.text}
        data-testid={`${fields.testid?.value}-label`}
      />
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const reduxValuePath = props.fields.reduxValuePath?.value;
  let defaultValue;
  if (reduxValuePath) {
    defaultValue = resolve(reduxValuePath, state);
  }
  return {
    ...props,
    defaultValue,
  };
};
export default connect(mapStateToProps)(CheckboxQuestionItem);
